import { ExtensionDefinition } from '@backstage/frontend-plugin-api';
import { EntityContentBlueprint } from '@backstage/plugin-catalog-react/alpha';

// CI/CD: service + website components (legacy service/website pages)
export const cicdContent: ExtensionDefinition = EntityContentBlueprint.make({
  name: 'cicd',
  params: {
    path: '/ci-cd',
    title: 'CI/CD',
    filter: {
      $any: [
        { kind: 'component', 'spec.type': 'service' },
        { kind: 'component', 'spec.type': 'website' },
      ],
    },
    loader: () =>
      import('../../components/catalog/CicdContent').then(m => (
        <m.CicdContent />
      )),
  },
});

// NOTE: no custom "API" tab here — the api-docs plugin (@backstage/plugin-api-docs/alpha)
// auto-provides an "APIs" entity content tab (provided/consumed APIs). The legacy custom
// API tab duplicated it, so we rely on the plugin's tab instead.

// Dependencies: service + website components (legacy service/website pages)
export const dependenciesContent: ExtensionDefinition =
  EntityContentBlueprint.make({
    name: 'dependencies',
    params: {
      path: '/dependencies',
      title: 'Dependencies',
      filter: {
        $any: [
          { kind: 'component', 'spec.type': 'service' },
          { kind: 'component', 'spec.type': 'website' },
        ],
      },
      loader: () =>
        import('../../components/catalog/DependenciesContent').then(m => (
          <m.DependenciesContent />
        )),
    },
  });

export const entityContent: ExtensionDefinition[] = [
  cicdContent,
  dependenciesContent,
];
